// Application constants

export const APP_CONFIG = {
  name: 'Stripe Payment Demo',
  version: '1.0.0',
  description: 'Send payment links and manage transactions',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  FAILED: 'failed',
  EXPIRED: 'expired',
};

export const PAYMENT_STATUS_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: PAYMENT_STATUS.PENDING, label: 'Pending' },
  { value: PAYMENT_STATUS.PAID, label: 'Paid' },
  { value: PAYMENT_STATUS.FAILED, label: 'Failed' },
  { value: PAYMENT_STATUS.EXPIRED, label: 'Expired' },
];

export const CURRENCIES = [
  { value: 'USD', label: 'USD - US Dollar' },
  { value: 'EUR', label: 'EUR - Euro' },
  { value: 'GBP', label: 'GBP - British Pound' },
  { value: 'CAD', label: 'CAD - Canadian Dollar' },
  { value: 'AUD', label: 'AUD - Australian Dollar' },
];

export const SERVICE_TYPES = [
  { value: 'ARRIVAL', label: 'Arrival Service', description: 'Airport arrival assistance' },
  { value: 'DEPARTURE', label: 'Departure Service', description: 'Airport departure assistance' },
  { value: 'TRANSIT', label: 'Transit Service', description: 'Complete arrival and departure service' },
];

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  LIMIT_OPTIONS: [5, 10, 25, 50, 100],
};

export const DATE_RANGES = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7days', label: 'Last 7 days' },
  { value: 'last30days', label: 'Last 30 days' },
  { value: 'last90days', label: 'Last 90 days' },
  { value: 'thisYear', label: 'This year' },
  { value: 'custom', label: 'Custom range' },
];

export const API_ENDPOINTS = {
  PAYMENTS: '/api/payments',
  WEBHOOKS: '/api/webhooks',
  HEALTH: '/health',
};

export const TOAST_CONFIG = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: 'light',
};

export const VALIDATION_RULES = {
  CLIENT_NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 100,
  },
  CLIENT_EMAIL: {
    MAX_LENGTH: 255,
  },
  DESCRIPTION: {
    MIN_LENGTH: 5,
    MAX_LENGTH: 500,
  },
  AMOUNT: {
    MIN: 0.01,
    MAX: 999999.99,
  },
};

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_AMOUNT: 'Please enter a valid amount',
  MIN_LENGTH: (min) => `Must be at least ${min} characters`,
  MAX_LENGTH: (max) => `Must be no more than ${max} characters`,
  MIN_VALUE: (min) => `Must be at least ${min}`,
  MAX_VALUE: (max) => `Must be no more than ${max}`,
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
};

export const SUCCESS_MESSAGES = {
  PAYMENT_CREATED: 'Payment request created successfully',
  PAYMENT_UPDATED: 'Payment request updated successfully',
  EMAIL_SENT: 'Email sent successfully',
  DATA_LOADED: 'Data loaded successfully',
};

export const BREAKPOINTS = {
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px',
};

export const ANIMATION_DURATION = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
};

export const DEBOUNCE_DELAY = 300;

export const REFRESH_INTERVALS = {
  PAYMENT_LIST: 30000, // 30 seconds
  PAYMENT_STATS: 60000, // 1 minute
};

export const EXPORT_FORMATS = {
  CSV: 'csv',
  PDF: 'pdf',
  EXCEL: 'xlsx',
};

export const THEME_COLORS = {
  PRIMARY: '#635bff',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  DANGER: '#ef4444',
  INFO: '#3b82f6',
  GRAY: '#6b7280',
};

export const LOCAL_STORAGE_KEYS = {
  THEME: 'stripe-demo-theme',
  FILTERS: 'stripe-demo-filters',
  PREFERENCES: 'stripe-demo-preferences',
};

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  CREATE_PAYMENT: '/create-payment',
  PAYMENT_DETAILS: '/payment/:id',
  SUCCESS: '/success',
  CANCEL: '/cancel',
  NOT_FOUND: '/404',
};
